import axios from "axios";
import Cookies from "universal-cookie";
import {
  SignInSuccess,
  UpdateProfile,
  UpdateTour,
} from "../Redux/UserSlice";


const BaseUrl = process.env.REACT_APP_BASE_SERVER_URI;
// const BaseUrl = "http://192.168.1.8:8080";
// const BaseUrl = "https://6dworks-lms-service-dev.vercel.app";
const cookies = new Cookies();
const RemoveAllCookies = () => {
  const allCookies = cookies.getAll();
  Object.keys(allCookies).forEach((name) => {
    cookies.remove(name);
  });
};
// const token = cookies.get("token");
// const userId = cookies.get("userId");
const ImageUrl = `${BaseUrl}/6D`;
const CourseImageUrl = `${BaseUrl}/6D/course_image/`;
// const NotificationUrl = (UID: number) => {
//   return `${BaseUrl}/6D/notifications/getAllNotifications/${UID}`;
// };
const NotificationUrl = (UID: number) => {
  return new URL(
    `6D/notifications/getAllNotifications/${UID}`,
    BaseUrl
  ).toString();
};
const Domainurl = (subdomain: string) => {
  return new URL(
    `6D/domain/${subdomain}`,
    BaseUrl
  ).toString();
};
const instance = axios.create({
  baseURL: BaseUrl,
});
instance.interceptors.request.use(
  (config) => {
    const token = cookies.get("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const Verify_Token = async (dispatch: any, navigate: any) => {
  const token = cookies.get("token");
  if (!token) {
    navigate("/signin");
    return false;
  }

  try {
    const response = await instance.get("/6D/auth/verify-token");
    if (response.status === 200) {
      dispatch(SignInSuccess(response.data.user.USER));
      dispatch(UpdateProfile(`${ImageUrl}${response.data.user.USER.profile}`));
      dispatch(UpdateTour(response.data.user.USER.tour));
      cookies.set("role", response.data.user.USER.role);
      cookies.set("tourModal", response.data.user.USER.tour);

      return true;
    } else {
      navigate("/signin");
      return false;
    }
  } catch (error) {
    console.error("Token verification failed:", error);
    navigate("/signin");
    return false;
  }
};

const GetAcessToken = async () => {
  const refreshToken = cookies.get("refreshToken");
  const userId = cookies.get("userId");

  if (!refreshToken || !userId) {
    return false;
  }

  try {
    const response = await instance.post("/6D/auth/getme", {
      refreshToken,
      userId,
    });

    if (response.status === 200) {
      cookies.set("token", response.data.AccessToken);
      return true;
    } else {
      return false;
    }
  } catch (error) {
    console.error("Failed to get access token:", error);
    return false;
  }
};

export {
  instance,
  BaseUrl,
  ImageUrl,
  CourseImageUrl,
  NotificationUrl,
  cookies,
  Verify_Token,
  GetAcessToken,
  RemoveAllCookies,
  Domainurl
};
